export const AI_CHAT_TOGGLE_EVENT = "ai-chat:toggle";

export const toggleAiChat = () => window.dispatchEvent(new Event(AI_CHAT_TOGGLE_EVENT));

export const AI_CHAT_STATUS_EVENT = "ai-chat:status";

export type AiChatStatus = { replying: boolean };

export type ChatViewMode = "sidebar" | "floating";

export type ChatHeaderViewMode = ChatViewMode | "fullscreen";

export const CHAT_OPEN_STATE_KEY = "ai-chat-panel-open";
export const CHAT_VIEW_MODE_KEY = "ai-chat-panel-view-mode";
export const AI_CHAT_DRAFT = "ai-chat-draft";

export const CHAT_URL = "/api/ai/chat";
export const MAX_MESSAGE_CHARS = 4000;
export const MESSAGE_COUNTER_THRESHOLD = 3500;
export const REGENERATE_URL = "/api/ai/chat/regenerate";
export const COMPACT_URL = "/api/ai/chat/compact";
